"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.AssertionErrorWithMeta = void 0;
const ErrorWithMeta_1 = require("./ErrorWithMeta");
class AssertionErrorWithMeta extends ErrorWithMeta_1.ErrorWithMeta {
    constructor(options, meta) {
        super(`AssertionError: ${options?.message} - got "${options?.actual}", expected "${options?.expected}"`, { options, meta });
    }
}
exports.AssertionErrorWithMeta = AssertionErrorWithMeta;
function assert(condition, message, meta) {
    if (!condition) {
        throw new AssertionErrorWithMeta({ message }, meta);
    }
}
exports.assert = assert;
//# sourceMappingURL=assert.js.map